'use client';

import { HelpCircle, BookOpen, MessageSquare } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useHelpStore } from '@/lib/help/store';
import { DocumentationTab } from './DocumentationTab';
import { ChatTab } from './ChatTab';

export function HelpPanel() {
  const isOpen = useHelpStore((s) => s.isOpen);
  const close = useHelpStore((s) => s.close);
  const activeTab = useHelpStore((s) => s.activeTab);
  const setActiveTab = useHelpStore((s) => s.setActiveTab);

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && close()}>
      <SheetContent
        side="right"
        className="w-[400px] sm:w-[540px] sm:max-w-[540px] p-0 flex flex-col"
      >
        <SheetHeader className="px-4 py-3 border-b flex-shrink-0">
          <SheetTitle className="flex items-center gap-2 text-base">
            <HelpCircle className="h-5 w-5" />
            Help & Documentation
          </SheetTitle>
        </SheetHeader>

        <Tabs
          value={activeTab}
          onValueChange={(v) => setActiveTab(v as 'docs' | 'chat')}
          className="flex-1 flex flex-col min-h-0"
        >
          <TabsList className="w-full grid grid-cols-2 px-4 py-2 h-auto gap-2 bg-transparent flex-shrink-0">
            <TabsTrigger
              value="docs"
              className="flex items-center gap-2 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
            >
              <BookOpen className="h-4 w-4" />
              <span>Documentation</span>
            </TabsTrigger>
            <TabsTrigger
              value="chat"
              className="flex items-center gap-2 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
            >
              <MessageSquare className="h-4 w-4" />
              <span>Ask AI</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent
            value="docs"
            className="flex-1 m-0 data-[state=inactive]:hidden overflow-hidden"
          >
            <DocumentationTab />
          </TabsContent>

          <TabsContent
            value="chat"
            className="flex-1 m-0 data-[state=inactive]:hidden overflow-hidden"
          >
            <ChatTab />
          </TabsContent>
        </Tabs>
      </SheetContent>
    </Sheet>
  );
}
